export enum NoteEntityClass {
  Form = 'Form',
  FormQualitySection = 'FormQualitySection',
}
